import { makeStyles } from "@material-ui/core";
import { DESKTOP_BREAKPOINT } from "../../consts";
import headerBgImg from "../../../../assets/images/mentor_profile/header_bg.png";

export const useHeaderStyles = makeStyles((theme) => ({
  headerWrapper: {
    position: "relative",
    width: "100%",
  },

  headerBgWrapper: {
    backgroundImage: `url(${headerBgImg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      background: "linear-gradient(180deg, #FFF0C7 80%, #FFFFFF 100%)",
    },
  },

  headerContent: {
    maxWidth: "1440px",
    margin: "0 auto",
    padding: "64px 96px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      flexDirection: "column",
      padding: "24px 16px 0",
      alignItems: "flex-start",
    },
  },

  profileSection: {
    display: "flex",
    alignItems: "center",
    gap: "32px",
    flex: 1,
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      gap: "16px",
      width: "100%",
    },
  },

  profileImageWrapper: {
    width: "192px",
    height: "192px",
    borderRadius: "48px",
    border: "8px solid #FFD461",
    overflow: "hidden",
    flexShrink: 0,
    backgroundColor: "#f5f5f5",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "96px",
      height: "96px",
      borderRadius: "24px",
      border: "4px solid #FFD461",
    },
  },

  profileImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  profileDetails: {
    display: "flex",
    flexDirection: "column",
    // gap: "4px",
  },

  mentorName: {
    fontSize: "56px",
    fontWeight: 700,
    color: "#404040",
    fontFamily: "'Inter', sans-serif",
    marginBottom: "12px",
    letterSpacing: "-4%",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "28px",
      marginBottom: "8px",
    },
  },

  nameRow: {
    display: "flex",
    alignItems: "center",
    gap: "48px",
    flexWrap: "wrap",
    marginBottom: "20px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      gap: "12px",
      marginBottom: "12px",
    },
  },

  nameActions: {
    display: "flex",
    gap: "12px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "100%",
      boxSizing: "border-box",
      flexWrap: "wrap",
      padding: "0 16px",
      margin: "0 0 24px 0",
      gap: "10px",
    },
  },

  nameActionBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 16px",
    border: "2px solid #404040",
    borderRadius: "16px",
    backgroundColor: "#FFFFFF",
    color: "#404040",
    fontSize: "16px",
    fontWeight: 700,
    fontFamily: "'Inter', sans-serif",
    cursor: "pointer",
    transition: "background-color 0.2s, border-color 0.2s",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      borderColor: "#222",
    },
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      flex: 1,
      height: "40px",
      boxSizing: "border-box",
      justifyContent: "center",
      gap: "4px",
      fontSize: "14px",
      padding: "8px 16px",
    },
  },

  
  editDetailsBtnWrapper: {
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      flexBasis: "100%",
      boxSizing: "border-box",
      gap: "10px",
    },
  },

  editDetailsBtn: {
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      flex: 1,
      minWidth: 0,
      justifyContent: "center",
      gap: "4px",
      fontSize: "14px",
      padding: "8px 16px",
    },
  },

  nameActionIcon: {
    width: "16px",
    height: "16px",
    fontSize: "16px !important",
    verticalAlign: "middle",
  },

  subjectsRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
    marginBottom: "8px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      display: "none",
    },
  },

  subjectsLabel: {
    fontSize: "16px",
    color: "#404040",
    fontWeight: 700,
    fontFamily: "'Inter', sans-serif",
    whiteSpace: "nowrap",
    letterSpacing: "-4%",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      display: "none",
    },
  },

  subjectChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 16px",
    borderRadius: "32px",
    border: "3px solid #FFD461",
    backgroundColor: "#fff",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 700,
    color: "#404040",
    fontFamily: "'Inter', sans-serif",
    letterSpacing: "-4%",
    cursor: "pointer",
    transition:
      "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
    "&:hover": {
      transform: "scale(1.08) translateY(-2px)",
      boxShadow: "0 4px 12px rgba(255, 212, 97, 0.4)",
      borderColor: "#FFC52E",
    },
    "& img": {
      width: "24px",
      height: "24px",
      transition: "transform 0.2s ease",
    },
    "&:hover img": {
      transform: "rotate(5deg) scale(1.1)",
    },

    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      display: "flex",
      gap: "8px",
      alignItems: "flex-start",
      padding: "8px 12px",
      border: "2px solid #FFD461",
      backgroundColor: "#fff",
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: 700,
      color: "#404040",
      fontFamily: "'Inter', sans-serif",
      "& img": {
        width: "16px",
        height: "16px",
      },
    },
  },

  infoRow: {
    display: "flex",
    flexDirection: "column",
    // alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",

    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      flexDirection: "column",
      gap: "4px",
      alignItems: "flex-start",
    },
  },

  infoItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",

    "& img": {
      width: "24px",
      height: "24px",
    },
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "12px",
      "& img": {
        width: "16px",
        height: "16px",
      },
    },
  },

  infoItemText: {
    fontSize: "16px",
    lineHeight: "24px",
    color: "#404040",
    letterSpacing: "-4%",
    fontWeight: 600,
    fontFamily: "'Inter', sans-serif",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "12px",
      lineHeight: "16px",
      "& img": {
        width: "16px",
        height: "16px",
      },
    },
  },

  badgeSection: {
    flexShrink: 0,
    marginTop: "-64px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      display: "none",
    },
  },

  badgeImage: {
    width: "256px",
    height: "256px",
    objectFit: "contain",
    borderBottomRightRadius: "48px",
    borderBottomLeftRadius: "48px",
    borderRight: "8px solid #FFFFFF",
    borderBottom: "8px solid #FFFFFF",
    borderLeft: "8px solid #FFFFFF",
    borderTop: "none",
    background:
      "linear-gradient(225deg, #FFFFFF 50%, #9999FF 70%, #FFFFFF 90%)",
    boxShadow: "0px -16px 32px 0px #FFFFFF inset",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "140px",
      height: "140px",
      borderBottomRightRadius: "24px",
      borderBottomLeftRadius: "24px",
      borderRight: "4px solid #FFFFFF",
      borderBottom: "4px solid #FFFFFF",
      borderLeft: "4px solid #FFFFFF",
    },
  },

  // Mobile-only sections
  mobileSubjectsSection: {
    display: "none",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      display: "block",
      padding: "16px 20px",
    },
  },

  mobileSubjectsLabel: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#404040",
    fontFamily: "'Inter', sans-serif",
    marginBottom: "4px",
    letterSpacing: "-4%",
  },

  mobileSubjectsChips: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  },

  mobileBadgeSection: {
    display: "none",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      padding: "16px 20px",
      background: "linear-gradient(135deg, #f5f0ff 0%, #ede5ff 100%)",
    },
  },

  mobileBadgeImg: {
    width: "96px",
    height: "96px",
    objectFit: "contain",
    flexShrink: 0,
  },

  mobileBadgeText: {
    fontSize: "16px",
    color: "#404040",
    fontFamily: "'Inter', sans-serif",
    letterSpacing: "-4%",
    fontWeight: 700,
  },
  mobileBadgeTextStrong: {
    color: "#6000F0",
  },
  subjectsChips: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      display: "none",
    },
  },
}));
